/* src/app/components/auth-usage-charts/auth-bar-chart/auth-bar-chart.component.css */
.bar-chart-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  height: 350px;
  margin: 0 auto;
}
.bar-chart-container canvas {
  width: 100% !important;
  height: 100% !important;
  touch-action: manipulation;
}
@media (max-width: 1024px) {
  .bar-chart-container {
    width: 100%;
    max-width: 450px;
    height: 300px;
  }
}
@media (max-width: 768px) {
  .bar-chart-container {
    width: 100%;
    max-width: 400px;
    height: 250px;
  }
}
@media (max-width: 480px) {
  .bar-chart-container {
    width: 100%;
    max-width: 350px;
    height: 300px;
  }
}
/*# sourceMappingURL=auth-bar-chart.component-Q2TOLH5Y.css.map */
